import globalApi from '@/request/globalApi/globalApi'

const END_POINT = '/api/register'

export const fetchRegisterSelectOfferRequest = token => globalApi.get(`${END_POINT}/select-offer/${token}`)

// MFC2-1631 — variante CONNECTEE du POST select-offer : globalApi porte le Bearer (contrairement a
// authApi), ce qui permet a l'API d'utiliser le customer Stripe de l'user connecte et d'accepter
// une methode de paiement deja enregistree (offer = { offerId, paymentMethodId? }).
export const postRegisterSelectOfferConnectedRequest = (token, offer, message) => globalApi.post(`${END_POINT}/select-offer/${token}`, offer, { message, dontAlertUser: true })

// MFC2-1631 (rework) — methodes de paiement enregistrees du tunnel, resolues par le TOKEN de l'orga
// (customer du contact d'urgence sollicite). Reservees au user connecte sollicite (sinon liste vide).
export const getRegisterSelectOfferPaymentMethodsRequest = token => globalApi.get(`${END_POINT}/select-offer/${token}/payment-methods`)

// MFC2-1631 (rework) — offres en attente d'acceptation pour l'USER connecte (contact d'urgence),
// independamment de la liste d'organisations (l'orga awaiting n'y figure pas). Alimente l'alerte.
export const getUserPendingOffersRequest = () => globalApi.get('/api/user/pending-offers')
